// @ts-nocheck
import React from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useOrgModules } from "@/contexts/OrgModulesContext";

interface ModuleGuardProps {
  module: string;
  children: React.ReactNode;
  /** Where to send users when the module is off. Defaults to the dashboard home. */
  redirectTo?: string;
  /** Render this instead of redirecting. */
  fallback?: React.ReactNode;
}

/**
 * Renders children only when the organization has the given module enabled.
 * While flags are loading it shows a spinner; when disabled it redirects home.
 */
const ModuleGuard: React.FC<ModuleGuardProps> = ({
  module,
  children,
  redirectTo = "/admin-dashboard",
  fallback,
}) => {
  const { isEnabled, isLoading } = useOrgModules();

  if (isLoading) {
    return (
      <div className="flex min-h-[30vh] items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!isEnabled(module)) {
    if (fallback !== undefined) return <>{fallback}</>;
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default ModuleGuard;
